export default function updateSignup() {
  const useTitle = true;
  const useDescription = true;
  const signupTitle = 'Email Newsletter Signup';
  const signupTdescription = 'Monthly news and updates delivered directly to your inbox!';
  const inputPlaceholder = 'Email Address';
  const buttonLabel = 'Subscribe';

  const $signupElement = $('.events-tier-container .emailSignup');
  const $signupText = $signupElement.find('.emailSignupText');

  $signupText.replaceWith(`
      <div class="signup-text">
        ${useTitle ? `<h2 class="signup-title">${signupTitle}</h2>` : ''}
        ${useDescription ? `<p class="signup-description">${signupTdescription}</p>` : ''}
      </div>
    `);

  $signupElement
    .find('.emailInputField, .emailInputSubmit')
    .wrapAll('<div class="input-container"></div>');
  $signupElement.find('.emailInputField input').val('').attr('placeholder', inputPlaceholder);
  $signupElement.find('.emailInputSubmit a').text(buttonLabel);
}
